import { memo, useCallback } from 'react';
import { IconButton } from '@mui/material';

import { AddIcon } from '@/assets/icons';
import { StyledTooltip } from './StyledTooltip';

type Props = {
  tooltip: string;
  disabled?: boolean;
  onAdd: () => void;
  onOpen?: () => void;
  tooltipWhenDisabled?: boolean;
};

function AccordionAddIconButtonComponent({
  tooltip,
  disabled,
  onAdd,
  onOpen,
  tooltipWhenDisabled = true,
}: Props) {
  const handleOnAddClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      if (!disabled) {
        onOpen?.();
        onAdd();
      }
    },
    [disabled, onAdd, onOpen],
  );

  return (
    <StyledTooltip
      title={tooltip}
      placement='bottom'
      openOnlyWhenDisabled={tooltipWhenDisabled}
      enterDelay={0}
      disabled={disabled}
    >
      <span>
        <IconButton
          disabled={disabled}
          onClick={handleOnAddClick}
          sx={{ padding: 0, border: 'none' }}
        >
          <AddIcon data-testid='add-icon' />
        </IconButton>
      </span>
    </StyledTooltip>
  );
}

export const AccordionAddIconButton = memo(AccordionAddIconButtonComponent);
